import { VStack, Grid, Box, Text, GridItem } from '@chakra-ui/react'
import { useFormContext } from 'react-hook-form'
import { OptionsSelect } from '../OptionsSelect'
import { CustomSelect } from '../CustomSelect'
import { ObservacoesForm } from '../ObservacoesForm'
import { DataHoraForm } from '../DataHoraForm'

export const FormAgendamento = () => {
  const { watch } = useFormContext()

  const agendamentoTipo = watch('agendamentoRetorno') ?? 'EMAIL'

  console.log('agendamentoTipo', agendamentoTipo)

  return (
    <VStack spacing={4} maxW="963px" w="full" mx="auto">
      <ObservacoesForm />
      <Grid gridTemplateColumns="250px 1fr" alignItems="center" w="full" gap={4}>
        <Text fontWeight="semibold" alignSelf="flex-start" textAlign="left" fontSize="15px" whiteSpace="nowrap">
          Como você deseja retornar o contato?
        </Text>

        <GridItem w="full" h="20px" bg="#378BBF" />
      </Grid>
      <Grid gridTemplateColumns="repeat(3,1fr)" gap={2} w="100%">
        <Box w="full">
          <CustomSelect value={agendamentoTipo} />
        </Box>
        <DataHoraForm />
      </Grid>
      <OptionsSelect optionSelected={agendamentoTipo} />
    </VStack>
  )
}
